// De vaste driedeling van een inzicht: wat, waarom, hoe (in de praktijk).
// Spiegel van de sleutels in functions/intelligence/insightSections.js — de
// server is de bron; hier alleen wat het scherm nodig heeft.
// AI-CONTEXT: See docs/features/intelligence-decca-opzet.md

/**
 * @typedef {object} InsightSections
 * @property {string} what - De bevinding: wat zien we, bij wie, hoe sterk
 * @property {string} why - Het mechanisme: waarom hangt dit samen
 * @property {string} how - In de praktijk: wat organisaties concreet doen
 */

export const SECTIONS = [
    { key: 'what', label: 'Wat', placeholder: 'De bevinding: wat zien we, bij wie, hoe sterk. Samenhang-taal, met de aantallen.' },
    { key: 'why', label: 'Waarom', placeholder: 'Het mechanisme: waarom hangt dit samen; wat begeleiders en deelnemers zeggen ("uit interviews met twee organisaties …").' },
    { key: 'how', label: 'Hoe (in de praktijk)', placeholder: 'Wat organisaties concreet doen. Geen namen; noem aantallen ("bij drie van de vijf organisaties …").' },
]

/**
 * Altijd drie strings. Een oud inzicht zonder driedeling maar mét tekst
 * krijgt die tekst in 'Wat', zodat er niets kwijtraakt bij het bewerken.
 * @param {{Sections?: object, Text?: string}|null} insight
 * @returns {InsightSections}
 */
export const sectionsOf = (insight) => {
    const src = insight && insight.Sections && typeof insight.Sections === 'object' ? insight.Sections : {}
    const s = (v) => (typeof v === 'string' ? v : '')
    const out = { what: s(src.what), why: s(src.why), how: s(src.how) }
    if (!out.what && !out.why && !out.how && insight && typeof insight.Text === 'string' && insight.Text.trim()) {
        out.what = insight.Text
    }
    return out
}

/** @param {InsightSections} a @param {InsightSections} b */
export const sameSections = (a, b) => a.what === b.what && a.why === b.why && a.how === b.how
